import type { WritableComputedRef } from "vue";

export type ViewMode = "list" | "map";

export function useUrlViewMode(): WritableComputedRef<ViewMode> {
  const route = useRoute();
  const router = useRouter();

  return computed<ViewMode>({
    get: () => (route.query.view === "map" ? "map" : "list"),
    set: (mode) => {
      const query = { ...route.query };
      if (mode === "map") {
        query.view = "map";
      } else {
        delete query.view;
        delete query.siteId;
      }
      router.push({ query });
    },
  });
}
